import { createSlice } from '@reduxjs/toolkit';
import { post } from '../../api';

export const billingSlice = createSlice({
    // Slice name, this should be always as page name.
    name: 'billing',

    // Initial state for the slice
    initialState: {
        data: {},
        status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
        error: null,
    },

    // Reducers will mutate the state, put all the state mutation method over here
    reducers: {
        initialize: (state, action) => {
            state.data = action.payload;
            state.status = 'succeeded';
            state.error = null;
        },
        error: (state, action) => {
            state.status = 'failed';
            state.error = action.payload;
        },
        loading: (state, action) => {
            state.status = action.payload ? 'loading' : 'succeeded';
        },
        initialLoading: (state, action) => {
            state.status = action.payload ? 'initialLoading' : 'succeeded';
        },
    },
});

export default billingSlice.reducer;

// Export all the reducers actions here
export const { initialize, error, loading, initialLoading } = billingSlice.actions;

// Public Selectors
export const selectBillingData = (state) => state.billing.data;
export const selectBillingStatus = (state) => state.billing.status;
export const selectBillingError = (state) => state.billing.error;

export const initializeAsync = (params) => async (dispatch) => {
    dispatch(initialLoading(true));
    const result = await post('custom/getTransactions', { accountIds: params.accountIds });
    if (result.isSuccess) {
        dispatch(
            initialize({
                records: result.data,
            })
        );
    } else {
        dispatch(error(result.errorMessage));
    }
};
